
import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';
import { buildChartConfig } from './dmarc-chart-config';
import { formatPercentageForChart } from './dmarc-chart-helpers';

const styles = theme => ( {
    columnLeft: {
        'text-align': 'left'
    },
    columnRight: {
        'text-align': 'right'
    },
    foreignObject: {
        overflow: 'visible'
    },
    gridContainer: {
        display: 'grid',
        'grid-auto-rows': 'minmax(30, auto)',
        'grid-template-columns': '1fr 1fr',
        padding: theme.spacing.unit
    },
    heading: {
        'grid-column': '1 / span 2'
    },
} );

const tooltipConfig = {
    height: 116,
    width: 260,
};

const calculateTooltipPosition = ( maxX, mouseX,  mouseY ) => {
    // Adjusts tooltip position to make sure it doesn't get cut off out of bounds
    let { width, height } = buildChartConfig( maxX );

    let desiredX = mouseX + 10;
    if( desiredX + tooltipConfig.width > width ){
        desiredX = mouseX - 10 - tooltipConfig.width;
    }

    let desiredY = mouseY + 10;
    if( desiredY + tooltipConfig.height > height ){
        desiredY = mouseY - 10 - tooltipConfig.height;
    }

    return [desiredX, desiredY];
};
const DmarcChartTooltip = ( { classes, maxX, mouseX, mouseY, data } ) => {
    let [leftPos, topPos] = calculateTooltipPosition( maxX, mouseX, mouseY );
    let totalVolumeCount = data.totalMailCount.toLocaleString();
    let friendlyAbuseRate = `${formatPercentageForChart( data.abuseRate )}%`;
    let singlePassRate = `${formatPercentageForChart( data.percentAuthorizedSinglePass )}%`;
    let doublePassRate = `${formatPercentageForChart( data.percentAuthorizedDoublePass )}%`;

    return (
        <foreignObject
            className={`${styles.tooltip} ${classes.foreignObject}`}
            x={leftPos}
            y={topPos}
            width={tooltipConfig.width}
            height={tooltipConfig.height}
        >
            <Paper className={classes.gridContainer} elevation={2} square={true}>
                <Typography className={classes.heading} color="textPrimary" variant="body1" gutterBottom>
                    <strong>{data.domainName}</strong>
                </Typography>
                <Typography className={classes.columnLeft} color="textSecondary" variant="caption" gutterBottom>
                    Abuse Rate
                </Typography>
                <Typography className={classes.columnRight} color="textPrimary" variant="caption" gutterBottom>
                    {friendlyAbuseRate}
                </Typography>
                <Typography className={classes.columnLeft} color="textSecondary" variant="caption" gutterBottom>
                    DMARC Policy
                </Typography>
                <Typography className={classes.columnRight} color="textPrimary" variant="caption" gutterBottom>
                    {data.friendlyPolicy}
                </Typography>
                <Typography className={classes.columnLeft} color="textSecondary" variant="caption" gutterBottom>
                    Total Volume
                </Typography>
                <Typography className={classes.columnRight} color="textPrimary" variant="caption" gutterBottom>
                    {totalVolumeCount}
                </Typography>
                <Typography className={classes.columnLeft} color="textSecondary" variant="caption" gutterBottom>
                    DMARC Single Pass
                </Typography>
                <Typography className={classes.columnRight} color="textPrimary" variant="caption" gutterBottom>
                    {singlePassRate}
                </Typography>
                <Typography className={classes.columnLeft}  color="textSecondary" variant="caption"gutterBottom>
                    DMARC Double Pass
                </Typography>
                <Typography className={classes.columnRight} color="textPrimary" variant="caption"gutterBottom>
                    {doublePassRate}
                </Typography>
            </Paper>
        </foreignObject> );
};

DmarcChartTooltip.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object.isRequired,
    maxX: PropTypes.number.isRequired,
    mouseX: PropTypes.number.isRequired,
    mouseY: PropTypes.number.isRequired,
};
export default withStyles( styles )( DmarcChartTooltip );
